import getCalendarItems from '../actions/getCalendarItems';
import FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import { getPublishedCalendarItems } from 'owa-publishedcalendar-service';
import {
    getCalendarFolderId,
    getDataFetchRange,
    getPublishedFolderPath,
} from 'owa-publishedcalendar-settings';
import { orchestrator } from 'satcheljs';
import setCalendarItems from '../actions/setCalendarItems';

/**
 * Orchestrator to get calendar items
 */
export default orchestrator(getCalendarItems, async actionMessage => {
    // If publishedFolderPath is not yet fetched, no need to get calendar items
    if (!getPublishedFolderPath()) {
        return;
    }

    let response = await getPublishedCalendarItems(
        getCalendarFolderId(),
        getDataFetchRange().start,
        getDataFetchRange().end,
        getPublishedFolderPath()
    );

    let { Body } = response;
    let { ResponseMessages } = Body;
    let { Items } = ResponseMessages;
    if (Items && Items.length > 0 && Items[0].ResponseClass == 'Success') {
        const items: FindItemResponseMessage = Items[0];
        if (items.RootFolder.TotalItemsInView > 0) {
            setCalendarItems(items.RootFolder.Items, true /*replaceAll*/);
        }
    } else {
        // TODO: VSO.59366 - error handling and logging
    }
});
